export const analyticsConfig = {
  // Prefer environment variable, fall back to the provided Measurement ID
  trackingId: (import.meta.env.VITE_GA_MEASUREMENT_ID as string) || 'G-1SV8TVCE0Q',
};
